import { Agency, agencyBasic } from '@app/models';
import { gql } from 'apollo-angular';


export interface Corridor {
  id: number;
  name: string;
  valid: boolean;
  agency: Agency;
}

export const corridor = gql`
  fragment corridor on Corridor {
    id
    name
    valid
    agency {
      ...agencyBasic
    }
  }
  ${agencyBasic}
`;
